




















































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'
import { Button, Icon } from '@/components/general'

// services
// import { AfpService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { AdvanceType } from '@/models/config'

export default defineComponent({
  name: 'AdvanceTypesTableList',
  components: {
    DataTable,
    IsActive,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<AdvanceType[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const fields = [
      {
        key: 'name',
        sortable: true,
        label: 'Descripción'
      },
      {
        key: 'apply_afp',
        sortable: true,
        label: 'Afecto AFP',
        formatter: (value: boolean) => {
          return value ? 'SI' : 'NO'
        }
      },
      {
        key: 'status_text',
        sortable: true,
        label: 'Status'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '15%'
        }
      }
    ]
    return {
      fields
    }
  }
})
